import React from 'react';
import PropTypes from 'prop-types';
import { ClipLoader } from 'react-spinners';

// Used for loading animations
const LoadingSpinner = (props) => (
  <div className={`LoadingSpinner${props.fullHeight ? ' full-height' : ''}`}>
    <ClipLoader color="#c5c5c5" size={60} sizeUnit="px" />
  </div>
);

LoadingSpinner.propTypes = {
  fullHeight: PropTypes.bool,
};

export default LoadingSpinner;
